import { Routes } from '@angular/router';
import { AdminCustomersViewComponent } from './content/components/admin/admin-customers-view/admin-customers-view.component';
import { AdminOnboardingComponent } from './content/components/admin/admin-onboarding/admin-onboarding.component';
import { AdminPaymentTypesViewComponent } from './content/components/admin/admin-payment-types-view/admin-payment-types-view.component';
import { AdminTransactionsViewComponent } from './content/components/admin/admin-transactions-view/admin-transactions-view.component';
import { DashboardComponent } from './content/components/dashboard/dashboard.component';
import { ErrorPageComponent } from './content/components/error-page/error-page.component';
import { GirocodeDummyComponent } from './content/components/girocode-dummy/girocode-dummy.component';
import { HelpContactComponent } from './content/components/help-contact/help-contact.component';
import { HelpFaqComponent } from './content/components/help-faq/help-faq.component';
import { LogoutPageComponent } from './content/components/logout-page/logout-page.component';
import { PaymentMethodEditComponent } from './content/components/payment-method-edit/payment-method-edit.component';
import { PaymentMethodsViewComponent } from './content/components/payment-methods-view/payment-methods-view.component';
import { PaymentPageComponent } from './content/components/payment-page/payment-page.component';
import { PayoutCreditcardViewComponent } from './content/components/payout-files/payout-creditcard-view/payout-creditcard-view.component';
import { PayoutSepaViewComponent } from './content/components/payout-files/payout-sepa-view/payout-sepa-view.component';
import { PayoutWeroViewComponent } from './content/components/payout-files/payout-wero-view/payout-wero-view.component';
import { TransactionsViewComponent } from './content/components/transactions-view/transactions-view.component';
import { organisationRzListResolver } from './content/resolver/organisation-rz-list.resolver';
import { referralPartnerListResolver } from './content/resolver/referral-partner-list.resolver';
import { TableRefreshWorkaroundComponent } from './core/components/table-refresh-workaround/table-refresh-workaround.component';
import { LayoutComponent } from './layout/components/layout/layout.component';

export const routes: Routes = [
  { path: '', component: LayoutComponent,
    children: [
      { path: 'dashboard', component: DashboardComponent },
      { path: 'paymentmethodsview', component: PaymentMethodsViewComponent },
      { path: 'paymentmethod/:id', component: PaymentMethodEditComponent },
      { path: 'transactionsview', component: TransactionsViewComponent },
      { path: 'paymentpage', component: PaymentPageComponent },
      { path: 'girocode', component: GirocodeDummyComponent },
      { path: 'helpfaq', component: HelpFaqComponent },
      { path: 'helpcontact', component: HelpContactComponent },
      { path: 'admincustomers', component: AdminCustomersViewComponent, resolve: { refPartnerList: referralPartnerListResolver, dataCenterList: organisationRzListResolver } },
      { path: 'adminonboarding', component: AdminOnboardingComponent , resolve: { refPartnerList: referralPartnerListResolver, dataCenterList: organisationRzListResolver } },
      { path: 'adminpaymenttypes/:parent/:tenantId', component: AdminPaymentTypesViewComponent },
      { path: 'admintransactions/:tenantId', component: AdminTransactionsViewComponent },
      { path: 'refreshworkaround/:redirect', component: TableRefreshWorkaroundComponent },
      { path: 'payoutcc', component: PayoutCreditcardViewComponent },
      { path: 'payoutsepa', component: PayoutSepaViewComponent },
      { path: 'payoutwero', component: PayoutWeroViewComponent },
    ]
  },
  { path: 'logout', component: LogoutPageComponent },
  { path: 'error', component: ErrorPageComponent },
  { path: 'error/:errortype', component: ErrorPageComponent },
  { path: '**', redirectTo: '' },
];
